import { combineReducers } from '@reduxjs/toolkit'

import authSlice from './modules/authSlice';
import appStateSlice from './modules/appStateSlice';
import plannerSlice from './modules/plannerSlice';
import plannerModalSlice from './modules/plannerSliceModals';
import plannerYellowBorderSlice from './modules/plannerYellowBorderSlice';
import plannerDraggingTripSlice from './modules/plannerDraggingTripSlice';
import plannerLoadingSlice from './modules/plannerLoadingSlice';
import pcrSlice from './modules/PcrSlice';
const rootReducer = combineReducers({
    authStore: authSlice,
    appState: appStateSlice,
    plannerStore: plannerSlice,
    plannerModalStore: plannerModalSlice,
    plannerYellowBorderStore: plannerYellowBorderSlice,
    plannerDraggingTripStore: plannerDraggingTripSlice,
    plannerLoadingStore: plannerLoadingSlice,
    pcrSlice:pcrSlice
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer